import React, { Component } from 'react';
import { Button } from '@material-ui/core';
import Badge from 'components/Badge/Badge.jsx';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ROLE_PROVIDER } from '../../utils/config/constants';
import withCustomTheme from '../HOC/HOCwithCustomTheme.jsx';

class HourlyService extends Component {
    render() {
        const { data, userData } = this.props;

        return (
            <div className="dir-alp-con-right-1">
                <div className="home-list-pop list-spac">
                    <h4> {data.serviceName} </h4>
                    <div className="badge-new" color="success">
                        <FormattedMessage
                            id="service.price"
                            defaultMessage="Price"
                        />
                        : {this.props.settings.constants.CURRENCY_SYMBOL}
                        {data.servicePrice}/{' '}
                        <FormattedMessage
                            id="prodetail.hour"
                            defaultMessage="hour"
                        />
                    </div>{' '}
                    <br />{' '}
                    {userData.role != ROLE_PROVIDER && (
                        <Button
                            className="btn-primary-new"
                            variant="contained"
                            color="primary"
                            onClick={() =>
                                this.props.clickBookNow(data.proServiceId, true)
                            }
                        >
                            <FormattedMessage
                                id="prodetail.booknow"
                                defaultMessage="Book Now"
                            />
                        </Button>
                    )}{' '}
                </div>
            </div>
        );
    }
}
export default withCustomTheme(HourlyService);



// WEBPACK FOOTER //
// ./src/components/Providers/HourlyService.js